import moment from 'moment-timezone';
import { GetContactName } from 'redux/actions/contacts';

const shiftMapper = (obj: any) => {
  return {
    ...obj,
    startDate: moment.tz(obj.startDate, obj.tz),
    endDate: moment.tz(obj.endDate, obj.tz),
    duration: obj.duration / 60, // Converting from seconds to minutes
    shouldChargeGst: !obj.isGstFree,
    contact: {
      ...obj.contact,
      name: GetContactName(obj.contact),
    },
    assignee: {
      ...obj.assignee,
      name: GetContactName(obj.assignee),
    },
  };
};
export default shiftMapper;
